import * as $ from 'jquery';
import * as _ from 'underscore';
import * as moment from 'moment';

import Bill from '../models/Bill';
import Room from '../models/Room';

export default class BillRepository {

    quote( arrival: moment.Moment, departure: moment.Moment, rooms: Room[], guests: { [name: string]: number } ): JQueryPromise<Bill> {
        if (_.isEmpty( rooms ))
            return $.when(new Bill( 0, 0, [] ));

        return $.post( '/api/bills',
                       _.reduce(
                           _.map(
                               rooms,
                               (r, i) => _.object([
                                   [`form[proposals][${i}][room]`, r.id],
                                   [`form[proposals][${i}][arrival]`, arrival.format('YYYY-MM-DD')],
                                   [`form[proposals][${i}][departure]`, departure.format('YYYY-MM-DD')],
                                   [`form[proposals][${i}][residents]`, guests[r.name]]
                               ])),
                           (form, proposal) => _.extend(form, proposal),
                           {}) ).
                 then( Bill.bless );
    }

}



/** WEBPACK FOOTER **
 ** ./src/repositories/BillRepository.ts
 **/